module.exports = __webpack_public_path__ + "img/doctor-hero.0df48dca.svg";